export default [
    {
        id: 1,
        type: 'featured',
        label: 'featured tours'
    }, {
        id: 2,
        type: 'all',
        label: 'all tours'
    }
];
